import { useState } from 'react';
import { BaseFields, FormComponents } from '@cks-internal/react-base';
import { useDebouncedCallback } from 'use-debounce';
import { Spinner } from '@chakra-ui/react';

type Props = {
  setSearchValue: (value: string) => void;
  isSearching?: boolean;
};

export const SearchInput = (props: Props) => {
  const [inputValue, setInputValue] = useState('');

  const debouncedSearch = useDebouncedCallback((value: string) => {
    props.setSearchValue(value);
  }, 500);

  return (
    <FormComponents.FormFieldContainer invalid={false}>
      <BaseFields.GenericInput
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          debouncedSearch(e.target.value);
        }}
        placeholder={'Product Search'}
        variant={'subtle'}
        elements={{
          rightElement: props.isSearching ? <Spinner size='sm' /> : undefined
        }}
      />
    </FormComponents.FormFieldContainer>
  );
};
